import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PaymentCardsService } from './services';
import { PaymentCardStateModule } from './+state/payment-cards.state.module';
import { PaymentCardsFacade } from './+state';

@NgModule({
  imports: [CommonModule, PaymentCardStateModule],
})
export class DomainPaymentCardsModule {
  public static forRoot(): ModuleWithProviders {
    return {
      ngModule: DomainPaymentCardsModule,
      providers: [PaymentCardsService, PaymentCardsFacade],
    };
  }
}
